import {FavoriteStore} from "../init";


const favoriteDeleteLocal = async (favoriteItemId) => FavoriteStore.remove(favoriteItemId);
export default favoriteDeleteLocal;